import * as UIKit from "~/src/modules/ui-kit";

import useParameter from "./useParameter";



export default function Parameter(props) {
    const { children, id, ...restProps } = props;

    const parameterQuery = useParameter(id);

    if (!id) return undefined;

    if (parameterQuery.loading) return <UIKit.CardSkeleton />;
    if (parameterQuery.error) return undefined;

    return (
        <UIKit.Card { ...restProps }>
            <UIKit.LetterBackdrop>P</UIKit.LetterBackdrop>
            <UIKit.CardFace2>
                <span className="fluid-accent">{ parameterQuery.data.parameter.name[0].text }</span>
                <span>{ parameterQuery.data.parameter.id }</span>
            </UIKit.CardFace2>
            { children }
        </UIKit.Card>
    );
}
